import React, { useEffect, useRef, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer } from "react-toastify";
import { getIcons } from "../../Constant/Constant";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import marketingHubService from "../../Services/MarketingHubService";
import Loader from "../../Constant/Loader";

const MarketingHubInfo = ({ message }) => {
  const [templateTypeOpen, setTemplateTypeOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [documentTemplates, setDocumentTemplates] = useState([]);
  const [isDocumentDeleteModal, setIsDocumentDeleteModal] = useState(false);
  const [copiedId, setCopiedId] = useState(null);
  const [textAndImageCount, setTextAndImageCount] = useState(0);
  const [documentsCount, setDocumentsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [searchList, setSearchList] = useState("");
  const [filteredTemplate, setFilteredTemplate] = useState([]);

  const [activeTab, setActiveTab] = useState("Messages");

  const location = useLocation();
  const { group, groupId } = location.state || {};
  const icons = getIcons();
  const navigate = useNavigate();
  const dropDownMenuRef = useRef(null);

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;

  console.log(message);
  if (location.state?.message) {
    showSuccessToast(location.state.message);
    navigate(location.pathname, { replace: true, state: {} });
  }
  // useEffect(() => {

  // }, [location, navigate]);

  const handleBack = () => {
    if (userRole === "Admin") {
      navigate(`/admin/marketing-hub`);
    } else if (userRole === "CMO") {
      navigate(`/cmo/marketing-hub`);
    }
  };

  const handleDropDownMenu = () => {
    setTemplateTypeOpen(!templateTypeOpen);
  };

  const fetchTemplates = async () => {
    setLoading(true);

    try {
      const response = await marketingHubService.getTextAndImage(groupId);
      const { templates, count } = response.data;

      setTemplates(templates);
      setTextAndImageCount(count);
    } catch (error) {
      showErrorToast(error.response.data);
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTemplates();
  }, [groupId]);
  const fetchDocumentTemplate = async () => {
    setLoading(true);

    try {
      const response = await marketingHubService.getDocuments(groupId);
      const { templates, count } = response.data;

      setDocumentTemplates(templates);
      setDocumentsCount(count);
    } catch (error) {
      showErrorToast(error.response.data);
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDocumentTemplate();
  }, [groupId]);

  const tabs = [
    { label: "Messages", count: textAndImageCount },
    { label: "Images", count: documentsCount },
    { label: "Documents", count: documentsCount },
    { label: "Link", count: documentsCount },
  ];
  const handleView = (template) => {
    if (userRole === "Admin") {
      navigate(`/admin/marketing-hub-bulkSend`, { state: { template } });
    } else if (userRole === "CMO") {
      navigate(`/cmo/marketing-hub-bulkSend`, { state: { template } });
    }
  };

  // Custom styles for Modal
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "35%",
      padding: "20px",
      position: "relative",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };
  Modal.setAppElement("#root");

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleCloseDocumentDeleteModal = () => {
    setIsDocumentDeleteModal(false);
  };

  const handleopenDeleteModal = (template) => {
    setTemplateId(template.templateId);
    setIsModalOpen(true);
  };

  const handleopenDocumentDeleteModal = (template) => {
    setTemplateId(template.templateId);
    setIsDocumentDeleteModal(true);
  };
  const handleDeleteTemplate = async () => {
    try {
      const response = await marketingHubService.deleteTemplate(templateId);
      setIsModalOpen(false);
      fetchTemplates(templates);
      showSuccessToast("Deleted Successfully");
      window.location.reload();
    } catch (error) {
      showErrorToast(error.response.data);
    }
  };
  const handleDeleteDocumentModal = async () => {
    try {
      const response = await marketingHubService.deleteDocumentTemplate(
        templateId
      );
      setIsDocumentDeleteModal(false);
      fetchDocumentTemplate(documentTemplates);
      showSuccessToast("Deleted Successfully");
    } catch (error) {
      showErrorToast(error.response.data);
    }
  };
  const handleEditTemplate = async (template) => {
    if (userRole === "Admin") {
      navigate(`/admin/update-textAndImage-template`, { state: { template } });
    } else if (userRole === "CMO") {
      navigate(`/cmo/update-textAndImage-template`, { state: { template } });
    }
  };

  // const handleSearch = (e)=>{
  //   setSearchList(e.target.value);
  //   const filteredResults = templates.filter((template)=>
  //   template.title.toLowerCase().includes(e.target.value.toLowerCase())
  //   )
  //   setFilteredTemplate(filteredResults)
  // }

  // const displayTemplates = searchList ? filteredTemplate : templates ;

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchList(searchValue);

    if (activeTab === "Messages") {
      const filteredResults = templates.filter((template) =>
        template.title.toLowerCase().includes(searchValue)
      );
      setFilteredTemplate(filteredResults);
    } else if (activeTab === "Documents") {
      const filteredResults = documentTemplates.filter((template) =>
        template.title.toLowerCase().includes(searchValue)
      );
      setFilteredTemplate(filteredResults);
    }
  };

  const displayTemplates =
    activeTab === "Text & Image"
      ? searchList
        ? filteredTemplate
        : templates
      : activeTab === "Documents"
      ? searchList
        ? filteredTemplate
        : documentTemplates
      : [];

  const handleCopyLink = (url) => {
    navigator.clipboard.writeText(url);
    console.log(url);
    setCopiedId(url);

    // Reset after 2 seconds
    setTimeout(() => {
      setCopiedId(null);
    }, 2000);
  };

  // Handle view document
  const handleViewDocument = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="bg-appGrayBackground pb-10 pt-20">
      {loading ? <Loader /> : ""}
       <AdminAppBar />
      <ToastContainer />
      <div className="flex mt-10 px-20 xl:px-6 justify-between gap-5">
        <div className="flex justify-between gap-10">
          <div className="flex gap-6">
            <svg
              onClick={handleBack}
              className="cursor-pointer"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
            <div>
              <h1 className="text-4xl font-semibold w-96 truncate ">{group}</h1>
            </div>
          </div>

          <div className="relative flex w-[700px] items-center">
            <img
              src={icons.searchIcon}
              alt=""
              className="absolute left-4 w-5 h-5"
            />
            <input
              type="text"
              placeholder="Search Template with title name"
              value={searchList}
              onChange={handleSearch}
              className="setup-search pl-10 pr-4 h-10 border-stone-400 shadow appearance-none border rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
        </div>
        <div>
          <button
            ref={dropDownMenuRef}
            onClick={handleDropDownMenu}
            className="border-2 border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
          >
            +Create a New
          </button>

          {templateTypeOpen && (
            <div className="absolute mt-3 bg-white rounded-md shadow-md w-44 py-2">
              <ul className="list-none">
                <li
                  onClick={() =>
                    navigate(
                      `/${
                        userRole === "Admin" ? "admin" : "cmo"
                      }/create-textAndImage-template`,
                      { state: { group: group, groupId: groupId } }
                    )
                  }
                  className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
                >
                  Messages
                </li>
                <li
                  onClick={() =>
                    navigate(
                      `/${
                        userRole === "Admin" ? "admin" : "cmo"
                      }/image-template`,
                      { state: { group: group, groupId: groupId } }
                    )
                  }
                  className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
                >
                  Image 
                </li>
                <li
                  onClick={() =>
                    navigate(
                      `/${
                        userRole === "Admin" ? "admin" : "cmo"
                      }/image-template`,
                      { state: { group: group, groupId: groupId } }
                    )
                  }
                  className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
                >
                  Documents
                </li>
                <li
                  onClick={() =>
                    navigate(
                      `/${
                        userRole === "Admin" ? "admin" : "cmo"
                      }/link-template`,
                      { state: { group: group, groupId: groupId } }
                    )
                  }
                  className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
                >
                  Links
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <div className="p-4 bg-white rounded-lg shadow-md w-12/12  mx-20 mt-5">
        {/* Tabs */}
        <div className="flex border-b mb-4">
          {tabs.map((tab) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(tab.label)}
              className={`px-4 py-2 -mb-px text-sm font-medium ${
                activeTab === tab.label
                  ? "border-b-2 border-green-500 text-green-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label} <span className="text-gray-400">({tab.count})</span>
            </button>
          ))}
        </div>
        {
          <div>
            {activeTab === "Messages" && (
              <div>
                {textAndImageCount != 0 ? (
                  <div className="space-y-2">
                    {displayTemplates.map((template, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-2 rounded-md"
                      >
                        <div className="flex items-center">
                          <span className="h-2 w-2 bg-green-500 rounded-full mr-2"></span>
                          <span className="text-sm font-medium text-gray-700">
                            Template Title: {template.title}
                          </span>
                        </div>
                        <div className="flex space-x-24 text-sm">
                          <button
                            onClick={() => handleView(template)}
                            className="text-blue-500 hover:underline"
                          >
                            View
                          </button>
                          <button
                            onClick={() => {
                              handleEditTemplate(template);
                            }}
                            className="text-blue-500 hover:underline"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => {
                              handleopenDeleteModal(template);
                            }}
                            className="text-red-500 hover:underline"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() =>
                      navigate(
                        `/${
                          userRole === "Admin" ? "admin" : "cmo"
                        }/create-textAndImage-template`,
                        { state: { group, groupId } }
                      )
                    }
                  >
                    <img className="w-20" src={icons.addUploadIcon} alt="" />
                    <p className="text-center text-lg font-light text-customGreen">
                      Click here to start creating content
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        }

        {activeTab === "Images" && (
          <div>
            {documentsCount != 0 ? (
              <div className="space-y-2">
                {displayTemplates.map((template, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-2 rounded-md"
                  >
                    <div className="flex items-center">
                      <span className="h-2 w-2 bg-green-500 rounded-full mr-2"></span>
                      <span className="text-sm font-medium text-gray-700">
                        Template Title: {template.title}
                      </span>
                    </div>
                    <div className="flex space-x-24 text-sm">
                      <button
                        onClick={() => handleViewDocument(template.documentUrl)}
                        className="text-blue-500 hover:underline"
                      >
                        View
                      </button>
                      <button
                        onClick={() => handleCopyLink(template.documentUrl)}
                        className="text-blue-500 hover:underline"
                      >
                        {copiedId === template.documentUrl
                          ? "Copied!"
                          : "Copy Link"}{" "}
                      </button>
                      <button
                        onClick={() => {
                          handleopenDocumentDeleteModal(template);
                        }}
                        className="text-red-500 hover:underline"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() =>
                  navigate(
                    `/${
                      userRole === "Admin" ? "admin" : "cmo"
                    }/image-template`,
                    { state: { group, groupId } }
                  )
                }
              >
                <img className="w-20" src={icons.addUploadIcon} alt="" />
                <p className="text-center text-lg font-light text-customGreen">
                  Click here to start creating content
                </p>
              </div>
            )}

            {searchList && filteredTemplate.length === 0 && (
              <p className="text-center text-gray-500">
                No templates found matching your search.
              </p>
            )}
          </div>
        )}

        {activeTab === "Documents" && (
          <div>
            {documentsCount != 0 ? (
              <div className="space-y-2">
                {displayTemplates.map((template, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-2 rounded-md"
                  >
                    <div className="flex items-center">
                      <span className="h-2 w-2 bg-green-500 rounded-full mr-2"></span>
                      <span className="text-sm font-medium text-gray-700">
                        Template Title: {template.title}
                      </span>
                    </div>
                    <div className="flex space-x-24 text-sm">
                      <button
                        onClick={() => handleViewDocument(template.documentUrl)}
                        className="text-blue-500 hover:underline"
                      >
                        View
                      </button>
                      <button
                        onClick={() => handleCopyLink(template.documentUrl)}
                        className="text-blue-500 hover:underline"
                      >
                        {copiedId === template.documentUrl
                          ? "Copied!"
                          : "Copy Link"}{" "}
                      </button>
                      <button
                        onClick={() => {
                          handleopenDocumentDeleteModal(template);
                        }}
                        className="text-red-500 hover:underline"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() =>
                  navigate(
                    `/${
                      userRole === "Admin" ? "admin" : "cmo"
                    }/create-document-template`,
                    { state: { group, groupId } }
                  )
                }
              >
                <img className="w-20" src={icons.addUploadIcon} alt="" />
                <p className="text-center text-lg font-light text-customGreen">
                  Click here to start creating content
                </p>
              </div>
            )}

            {searchList && filteredTemplate.length === 0 && (
              <p className="text-center text-gray-500">
                No templates found matching your search.
              </p>
            )}
          </div>
        )}

        {activeTab === "Link" && (
          <div>
            {documentsCount != 0 ? (
              <div className="space-y-2">
                {displayTemplates.map((template, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-2 rounded-md"
                  >
                    <div className="flex items-center">
                      <span className="h-2 w-2 bg-green-500 rounded-full mr-2"></span>
                      <span className="text-sm font-medium text-gray-700">
                        Template Title: {template.title}
                      </span>
                    </div>
                    <div className="flex space-x-24 text-sm">
                      <button
                        onClick={() => handleViewDocument(template.documentUrl)}
                        className="text-blue-500 hover:underline"
                      >
                        View
                      </button>
                      <button
                        onClick={() => handleCopyLink(template.documentUrl)}
                        className="text-blue-500 hover:underline"
                      >
                        {copiedId === template.documentUrl
                          ? "Copied!"
                          : "Copy Link"}{" "}
                      </button>
                      <button
                        onClick={() => {
                          handleopenDocumentDeleteModal(template);
                        }}
                        className="text-red-500 hover:underline"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() =>
                  navigate(
                    `/${
                      userRole === "Admin" ? "admin" : "cmo"
                    }/link-template`,
                    { state: { group, groupId } }
                  )
                }
              >
                <img className="w-20" src={icons.addUploadIcon} alt="" />
                <p className="text-center text-lg font-light text-customGreen">
                  Click here to start creating content
                </p>
              </div>
            )}

            {searchList && filteredTemplate.length === 0 && (
              <p className="text-center text-gray-500">
                No templates found matching your search.
              </p>
            )}
          </div>
        )}
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Delete Template"
        style={customStyles}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>

        <h2 className="text-xl text-center font-normal mb-4">
          Are you sure to delete this template ?
        </h2>
        <div className="flex justify-between px-20 mt-10">
          <button
            onClick={handleCloseModal}
            className="bg-gray-400 text-white  rounded-md w-20 font-normal"
          >
            Cancel
          </button>
          <button
            className="bg-customGreen text-white  w-20 rounded-md  font-normal"
            onClick={handleDeleteTemplate}
          >
            Yes
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isDocumentDeleteModal}
        onRequestClose={handleCloseDocumentDeleteModal}
        contentLabel="Delete Template"
        style={customStyles}
      >
        <button
          onClick={handleCloseDocumentDeleteModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>

        <h2 className="text-xl text-center font-normal mb-4">
          Are you sure to delete this template ?
        </h2>
        <div className="flex justify-between px-20 mt-10">
          <button
            onClick={handleCloseDocumentDeleteModal}
            className="bg-gray-400 text-white  rounded-md w-20 font-normal"
          >
            Cancel
          </button>
          <button
            className="bg-customGreen text-white  w-20 rounded-md  font-normal"
            onClick={handleDeleteDocumentModal}
          >
            Yes
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default MarketingHubInfo;
